import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import classes from './HtmlTooltip.module.css';

const K2AHtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'white',
        color:           'black',
        fontSize:        theme.typography.pxToRem(12),
        border:          '1px solid grey',
        borderRadius:    '5px'
    }
}))(Tooltip);

const HtmlTooltip = (props) => {
    const {information, placement, body, disableHoverStatus = false} = props;

    return (
        <div>
            <K2AHtmlTooltip
                title={
                    <span className={classes.Tooltip}>
                        {information}
                    </span>
                }
                placement={placement}
                disableHoverListener={disableHoverStatus}
            >
                {body}
            </K2AHtmlTooltip>
        </div>
    );
};

export default HtmlTooltip;
